import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import buildingsData from "../../data/buildings.json";
import "./FirstSalesRow.css";
import { AsyncImage } from "loadable-image";
import FadeUp from "../FadeUp/FadeUp";

const FirstSalesRow = ({ isAlbanian }) => {
  const [buildings, setBuildings] = useState([]);
  const imagesLoaded = useRef(0);

  useEffect(() => {
    setBuildings(buildingsData);
  }, []);

  const handleImageLoad = () => {
    imagesLoaded.current += 1;
  };

  return (
    <div>
      <div className="firstsalesrow-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="firstsalesrow-title">
            {isAlbanian ? "Kataloget tona" : "Our Catalogs"}
          </div>
          <div className="bottom-line"></div>
        </div>
        <div className="firstsalesrow-grid">
          {buildings.map((building) => (
            <FadeUp key={building.building_id}>
              <Link
                className="firstsalesrow-card"
                key={building.building_id}
                to={`/secondstep/${building.building_id}`}
                onClick={(e) => {
                  if (!e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    window.location.href = `/secondstep/${building.building_id}`;
                  }
                }}
              >
                <div className="firstsalesrow-image-square">
                  <AsyncImage
                    src={building.building_image_url}
                    alt={building.building_title}
                    className="firstsalesrow-image"
                    loading="lazy"
                    onLoad={handleImageLoad}
                  />
                </div>
                <div className="firstsalesrow-content">
                  <h3 className="firstsalesrowcard-title">
                    {isAlbanian
                      ? building.titulli_nderteses
                      : building.building_title}
                  </h3>
                  <p className="firstsalesrow-address">
                    {isAlbanian
                      ? building.adresa_nderteses
                      : building.building_adress}
                  </p>
                  <p className="firstsalesrow-lookmore">
                    {isAlbanian ? "Shiko më shumë →" : "Look more →"}
                  </p>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FirstSalesRow;
